<div class="modal-content am-modal-content modal-xl text-white bg-am-medium-blue" style="background: transparent !important;">
  <div class="d-flex bg-am-medium-blue align-baseline justify-content-center p-4 bg-am-medium-blue">
        <div class="margin-title">
            <p class="aling-title"> {{ 'findYouPNR' | translate}} </p>
            <p class="aling-subtitle"> {{ 'pnrCompose' | translate}} </p>
            <p class="aling-subtitle"> {{ 'example' | translate}}:&nbsp;GKS8BZ</p>
        </div>
        <div class="am-close-div bg-am-medium-blue">
            <button type="button" class=" text-am-white am-modal-close" (click)="modal.dismiss()">
                <img src="../../../../assets/images/close.svg" alt="close">
            </button>
        </div>
    </div>
    <div class="bg-am-medium-blue d-flex flex-column am-padding-body p-3 bg-am-medium-blue body-modal">
        <div class="d-flex flex-row justify-content-center my-3">
            <div class="zone-helper d-flex flex-row flex-wrap flex-grow-1 justify-content-around fs-22px text-center">
                <div class="helper d-flex flex-column align-items-center justify-content-center">
                    <div>
                        <img src="../../../../assets/images/app.svg">
                    </div>
                    <div class="text-img--app">
                        {{ 'finderpnr.app' | translate }}
                    </div>

                </div>

                <div class="helper d-flex flex-column align-items-center justify-content-center">
                    <div>
                        <img src="../../../../assets/images/correo.svg">
                    </div>
                    <div class="text-img--app">
                        {{ 'finderpnr.correo' | translate }}
                    </div>
                </div>
                <div class="helper d-flex flex-column align-items-center justify-content-center">
                    <div>
                        <img src="../../../../assets/images/reservacion.svg">
                    </div>
                    <div class="text-img--app">
                        {{ 'finderpnr.reservation' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


